// extracted by mini-css-extract-plugin
export var callCard = "_qd-0";
export var callMessageButton = "_qd-1";
export var helpIcon = "_qd-3";
export var helpIconContainer = "_qd-4";
export var verticalDivider = "_qd-2";